import { render } from "./RecentlyViewedPagesComponent.vue?vue&type=template&id=7289b798&ts=true"
import script from "./RecentlyViewedPagesComponent.vue?vue&type=script&lang=ts"
export * from "./RecentlyViewedPagesComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__